import { Services } from '@smiles/voebiz-core-beneficiaries';
import {
  ICreateBeneficiarieRequest,
  IGetBeneficiariesRequest,
} from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiariesApi.types';
import { IGetBeneficiaryBatchHistoryRequest } from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiaryBatchHistoryApi.types';
import { IUpdateBeneficiaryRequest } from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiaryByDocumentApi.types';

export async function createBeneficiary(params: ICreateBeneficiarieRequest) {
  return Services.postBeneficiary(params);
}
export async function getBeneficiariesList(params?: IGetBeneficiariesRequest) {
  return Services.getBeneficiaries(params);
}

export async function getCreateBatchHistory(params?: IGetBeneficiaryBatchHistoryRequest) {
  return Services.getBeneficiaryBatchHistory(params);
}

export function getFileImportDetails(filename: string) {
  return Services.getBeneficiaryFileDetails({ filename });
}

export async function getBeneficiariesByCpf(document: string) {
  return Services.getBeneficiaryByDocument({ document });
}

export async function updateBeneficiary(beneficiary: IUpdateBeneficiaryRequest) {
  return Services.putBeneficiaryByDocument(beneficiary);
}

export async function createBeneficiariesBatch(file: string) {
  return Services.postBeneficiariesBatch({ file });
}

export async function deleteBeneficiariesBatch(file: string) {
  return Services.postBeneficiariesBatch({ file, action: 'DS' });
}

export async function mockGetStatus() {
  return new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(true);
      return true;
    }, 2000);
  });
}
